/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Irrigation_Error_Invalid_BodyInputs */

const vi_smartlab_irrigation_error_invalid_body = /** @type {(inputs: Smartlab_Irrigation_Error_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dữ liệu cấu hình phun nước gửi lên không hợp lệ, vui lòng tải lại trang rồi lưu lại`)
};

/**

* @param {Smartlab_Irrigation_Error_Invalid_BodyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_irrigation_error_invalid_body = /** @type {((inputs?: Smartlab_Irrigation_Error_Invalid_BodyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Irrigation_Error_Invalid_BodyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_irrigation_error_invalid_body(inputs)
});